import { render, staticRenderFns } from "./HowToRegister.vue?vue&type=template&id=40e65de6&"
import script from "./HowToRegister.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HowToRegister.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40e65de6')) {
      api.createRecord('40e65de6', component.options)
    } else {
      api.reload('40e65de6', component.options)
    }
    module.hot.accept("./HowToRegister.vue?vue&type=template&id=40e65de6&", function () {
      api.rerender('40e65de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/HowToRegister.vue"
export default component.exports